import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectOSXFontSmoothing } from "../../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectTypography } from "../../../utils/injectTypography.mjs.mjs";
export const StyledTitleBar = styled.div.withConfig({ displayName: "auir-611444a-StyledTitleBar", componentId: "auir-611444a-1rrabhy" }) `
  display: grid;
  flex-shrink: 0;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 64px;
  padding: var(${(props) => props.theme.responsive.spacing.xs});

  column-gap: var(${(props) => props.theme.responsive.spacing.l});

  background-color: var(${(props) => props.theme.colors.base.grey[100]});
  border-bottom: 1px solid var(${(props) => props.theme.colors.base.grey[80]});

  & > *:first-child {
    justify-self: start;
  }

  & > *:last-child {
    justify-self: end;
  }
`;
export const StyledCancelIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledCancelIcon", componentId: "auir-611444a-yk3q1h" }) ``;
export const StyledTitleBarButton = styled.button.withConfig({ displayName: "auir-611444a-StyledTitleBarButton", componentId: "auir-611444a-1iqc3q1" }) `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 48px;
  margin: 0;
  padding: var(${(props) => props.theme.responsive.spacing.s});

  color: var(${(props) => props.theme.colors.base.grey[0]});

  &:hover,
  &:focus {
    color: var(${(props) => props.theme.colors.base.grey[30]});
  }

  background-color: transparent;
  border: none;

  cursor: pointer;

  appearance: none;

  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}
`;
export const StyledTitle = styled.span.withConfig({ displayName: "auir-611444a-StyledTitle", componentId: "auir-611444a-1cwg7z7" }) `
  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}

  color: var(${(props) => props.theme.colors.base.grey[0]});
  font-weight: var(${(props) => props.theme.fontWeights.bold});
`;
//# sourceMappingURL=MobileOverlay.styles.mjs.mjs.map